import Box from "@mui/material/Box";
import React from "react";
import CustomerRequestsEdges from "../edges/CustomerRequestsEdges";
import {Typography} from "@mui/material";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import {
    buildMySamplesSectionPath,
    CUSTOMER_EDGES_SUBMENU_BREADCRUMB,
} from "../../../utils/customerBreadcrumbLabels";

const SamplesEdges = ({system, settings}) => {
    return <Box sx={{padding: settings ? 0 : "0 30px"}}>
        {!settings && <BreadcrumbsComponent
            page={CUSTOMER_EDGES_SUBMENU_BREADCRUMB.name}
            path={buildMySamplesSectionPath()}
        />}
        <CustomerRequestsEdges samples={true} system={system} settings={settings}/></Box>
}
export default SamplesEdges